import Dropdown from "@/components/common/Dropdown"
import { AddIcon } from "@/components/icons"
import { MobileFiltersProps } from "@/data/types"
import { formatNumber, getCityOptions, getPropertyTypeOptions, getStatusOptions } from "@/utils/helpers"
import clsx from "clsx"


export default function MobileFilters({ translations, selectedCity, availableCities, selectedPropertyType, availablePropertyTypes, 
  priceFrom, priceTo, selectedStatus, availableStatuses, mobileOpen, setMobileOpen, handleCityChange, handlePropertyTypeChange, handlePriceFromChange, 
  handlePriceToChange, handleStatusChange, onApplyFilters, onClearFilters }: MobileFiltersProps) {

  const cityOptionsFormatted = getCityOptions(availableCities, translations)
  const propertyTypeOptionsFormatted = getPropertyTypeOptions(availablePropertyTypes, translations)
  const statusOptionsFormatted = getStatusOptions(availableStatuses, translations)

  const handleApplyFilters = () => {
    onApplyFilters?.({
      city: selectedCity,
      propertyType: selectedPropertyType,
      priceFrom: priceFrom === "" ? undefined : Number(priceFrom),
      priceTo: priceTo === "" ? undefined : Number(priceTo),
      status: selectedStatus
    })
    setMobileOpen(false)
  }

  const handleClearFilters = () => {
    // handleCityChange("")
    handlePropertyTypeChange("")
    handlePriceFromChange("379000")
    handlePriceToChange("410000000")
    handleStatusChange("")

    onClearFilters?.() 
    setMobileOpen(false)
  }

  return (
    <>
      <div className="lg:hidden flex justify-between items-center">
        <button onClick={() => setMobileOpen(true)} className="border border-[#302E2D]/20 px-[15px] leading-[40px] cursor-pointer rounded-[10px] text-[#A58760] text-[14px] font-normal
          flex flex-row gap-[11px] items-center">
          {translations?.allFilters as string}
          <AddIcon width={11} height={11} />
        </button>
      </div>

      {/* Overlay & Bottom Sheet */}
      <div className={clsx("fixed inset-0 z-100 flex justify-center items-end transition-opacity duration-300",
        mobileOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none")}
      >
        {/* Backdrop */}
        <div className={clsx("absolute inset-0 bg-black/40 transition-opacity duration-300",
          mobileOpen ? "opacity-100" : "opacity-0")} onClick={() => setMobileOpen(false)}
        />

        {/* Bottom Sheet */}
        <div className={clsx("relative bg-white rounded-t-2xl p-[30px] w-full max-h-[80vh] overflow-y-auto shadow-lg transform transition-transform duration-300",
          mobileOpen ? "translate-y-0" : "translate-y-full", "flex flex-col gap-[20px]")}
        >
          <div className="flex justify-between items-center">
            <h3 className="text-lg">{translations?.filters as string}</h3>
            <button onClick={() => setMobileOpen(false)} className="cursor-pointer">✕</button>
          </div>

          <div className="border border-[#302E2D]/20 px-[15px] py-[7px] rounded-[10px] text-[#1B1D2B] flex flex-row gap-[15px]">
            {/* <Dropdown
              options={cityOptionsFormatted}
              value={selectedCity}
              onChange={(value) => handleCityChange(value as string)}
              label={translations?.cityLabel as string}
              zIndex={1000}
            />
  
            <div className="w-px bg-[#302E2D]/20 my-1" /> */}
  
            <Dropdown
              options={propertyTypeOptionsFormatted}
              value={selectedPropertyType}
              onChange={(value) => handlePropertyTypeChange(value as string)}
              label={translations?.propertyTypeLabel as string}
              zIndex={1000}
            />
          </div>

          <div className="h-[54px] border border-[#302E2D]/20 px-[15px] py-[7px] rounded-[10px] text-[#1B1D2B] text-[14px] flex flex-row gap-[18px]">
            <div className="relative w-[135px] flex flex-1">
              <input
                type="text" 
                placeholder={translations?.from as string}
                className="w-full border-none focus:outline-none focus:ring-0 pr-[40px] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&-moz-appearance:textfield]"
                value={formatNumber(priceFrom)}
                onChange={(e) => handlePriceFromChange(e.target.value.replace(/\s/g, ""))}
              />
              <span className="absolute right-0 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] text-[13px] leading-[27px] font-normal">
                AED
              </span>
            </div>
  
            <div className="w-px bg-[#302E2D]/20 my-1" />
  
            <div className="relative w-[135px] flex flex-1">
              <input
                type="text"
                className="w-full border-none focus:outline-none focus:ring-0 pr-[40px] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&-moz-appearance:textfield]"
                value={formatNumber(priceTo)}
                onChange={(e) => handlePriceToChange(e.target.value.replace(/\s/g, ""))}
              />
              <span className="absolute right-0 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] text-[13px] leading-[27px] font-normal">
                AED
              </span>
            </div>
          </div>

          <div className="border border-[#302E2D]/20 w-full h-[54px] px-[15px] py-[7px] rounded-[10px] text-[#1B1D2B] text-[14px] flex flex-row gap-[18px]">
            <Dropdown
              options={statusOptionsFormatted}
              value={selectedStatus}
              onChange={(value) => handleStatusChange(value as string)}
              label={translations?.statusLabel as string}
              zIndex={1000}
            />
          </div>

          <div className="flex gap-3 mt-4">
            <button
              onClick={handleClearFilters}
              className="flex-1 border border-[#302E2D]/20 text-[#302E2D] py-3 rounded-lg"
            >
              {translations?.clear as string || "Clear"}
            </button>
            <button
              onClick={handleApplyFilters}
              className="flex-1 bg-[#A58760] text-white py-3 rounded-lg"
            >
              {translations?.apply as string || "Apply"}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
